// eslint-disable-next-line no-restricted-imports -- approved output-boundary shim for billboard consumers
import { List, Map, OrderedMap, fromJS } from 'immutable';

import {
  PUT_CUSTOM_EXTRA_FIELDS_IN_STORE,
  SET_EXTRA_RELAY_BOX_FIELDS,
  SET_EXTRA_STRUCTURE_BOX_FIELDS,
  SET_SCHEDULE_VIEW,
  SET_STRUCTURE,
  TOGGLE_EXTRA_RELAY_BOX_FIELD,
  TOGGLE_EXTRA_STRUCTURE_BOX_FIELD,
} from '@sophocles/features/sites/slices/selectedStructure/actions';

function getState(state, action) {
  switch (action.type) {
    case SET_STRUCTURE:
      return { selectedStructure: action.structure };
    case TOGGLE_EXTRA_STRUCTURE_BOX_FIELD:
      return {
        extraStructureFields: state.extraStructureFields.setIn(
          [action.field, 'show'],
          !state.extraStructureFields.getIn([action.field, 'show']),
        ),
      };

    case SET_EXTRA_STRUCTURE_BOX_FIELDS:
      return {
        extraStructureFields: action.fields
          ? state.extraStructureFields.map(field =>
              field.set('show', action.fields.indexOf(field.get('id', '-1')) > -1),
            )
          : state.extraStructureFields,
      };

    case PUT_CUSTOM_EXTRA_FIELDS_IN_STORE:
      let newFieldsMap = state.extraStructureFields;
      List(action.fields).forEach(field =>
        !newFieldsMap.has('user_' + field)
          ? (newFieldsMap = newFieldsMap.set(
              'user_' + field,
              Map({
                id: 'user_' + field,
                show: false,
                title: field,
              }),
            ))
          : null,
      );
      return { extraStructureFields: newFieldsMap };

    case TOGGLE_EXTRA_RELAY_BOX_FIELD:
      return {
        extraRelayFields: state.extraRelayFields.setIn(
          [action.field, 'show'],
          !state.extraRelayFields.getIn([action.field, 'show']),
        ),
      };

    case SET_EXTRA_RELAY_BOX_FIELDS:
      return {
        extraRelayFields: action.fields
          ? state.extraRelayFields.map(field => field.set('show', action.fields.indexOf(field.get('id', '-1')) > -1))
          : state.extraRelayFields,
      };

    case SET_SCHEDULE_VIEW:
      return { scheduleView: action.view };

    default:
      return state;
  }
}

const initialState = {
  selectedStructure: 0,
  scheduleView: 'list',
  extraStructureFields: OrderedMap({
    tag_number: Map({
      id: 'tag_number',
      show: false,
      title: 'Security Tag',
    }),
    utility_meter_number: Map({
      id: 'utility_meter_number',
      show: false,
      title: 'Meter Number',
    }),
    utility_company: Map({
      id: 'utility_company',
      show: false,
      title: 'Utility Company',
    }),
    utility_account_number: Map({
      id: 'utility_account_number',
      show: false,
      title: 'Utility Account',
    }),
  }),
  extraRelayFields: OrderedMap({
    direction: Map({
      id: 'direction',
      show: false,
      title: 'Direction',
    }),
    fixture: Map({
      id: 'fixture',
      show: false,
      title: 'Fixture',
    }),
    number_of_fixtures: Map({
      id: 'number_of_fixtures',
      show: false,
      title: 'Fixture Qty',
    }),
  }),
  receivedEntities: Map(),
  fetchFields: Map(),
};

function structureReducer(state = initialState, action) {
  switch (action.type) {
    case SET_STRUCTURE:
    case SET_EXTRA_STRUCTURE_BOX_FIELDS:
    case TOGGLE_EXTRA_STRUCTURE_BOX_FIELD:
    case PUT_CUSTOM_EXTRA_FIELDS_IN_STORE:
    case TOGGLE_EXTRA_RELAY_BOX_FIELD:
    case SET_EXTRA_RELAY_BOX_FIELDS:
    case SET_SCHEDULE_VIEW:
      return Object.assign({}, state, getState(state, action));
    default:
      return state;
  }
}

export default structureReducer;
